import React from "react";
import styles from "./EbookCard.module.css";
import { useNavigate } from "react-router-dom";

const EbookCard = ({ book }) => {
  const navigate = useNavigate();

  // Function to truncate text to specified word count
  const truncateText = (text, wordCount) => {
    if (!text) return "";
    const words = text.split(" ");
    if (words.length <= wordCount) return text;
    return words.slice(0, wordCount).join(" ") + "...";
  };

  // Navigate function to avoid code duplication
  const navigateToBook = () => {
    const path = book.series_id
      ? `/book/${book.series_id}/episode/${book.slug}`
      : `/book/${book.slug}`;
    navigate(path, {
      state: {
        bookId: book.id,
        bookTitle: book.title,
      },
    });
  };

  // Navigate to book details
  const navigateToDetails = () => {
    const detailsPath = book.series_id
      ? `/book-details/${book.slug}`
      : `/book-detail/${book.slug}`;
    navigate(detailsPath);
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        {/* Add explicit background color to prevent iOS grey rendering */}
        <div className={styles.imageWrapper}>
          <img
            className={styles.image}
            onClick={navigateToBook}
            src={book.image || "/placeholder-image.jpg"}
            onLoad={(e) => {
              e.target.style.display = "none";
              e.target.style.display = "";
            }}
            alt={book.title}
          />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.category}>
          {book.category || "Category"} |{" "}
          {(book.tags && book.tags[0]) || "Ebook"}
          {book.author && <span> | by {book.author}</span>}
        </div>
        <h3 className={styles.bookTitle}>{book.title || "Book Title"}</h3>
        <p className={styles.description}>
          {truncateText(book.summary || "No description available", 6)}
        </p>
        <div className={styles.buttons}>
          <button
            className={`${styles.readButton} ${styles.readNow}`}
            onClick={navigateToBook}
          >
            Read Now
          </button>
          <button
            onClick={navigateToDetails}
            className={`${styles.readButton} ${styles.details}`}
          >
            Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default EbookCard;
